import { qantasTail } from 'images';
import { notificationsApiAvailable, permissionGranted, appHidden } from './helpers';
import { captureErrorInSentry } from 'lib/captureInSentry';
import { liveChatNotificationPermissionGranted, liveChatNotificationPermissionDenied } from 'lib/gaTracking/crossPageEvents';

const canSendNotification = () => notificationsApiAvailable() && permissionGranted() && appHidden();

export const requestNotificationPermission = async () => {
  try {
    if (notificationsApiAvailable() && !permissionGranted()) {
      await Notification.requestPermission();

      if (Notification.permission === 'granted') {
        liveChatNotificationPermissionGranted();
      } else if (Notification.permission === 'denied') {
        liveChatNotificationPermissionDenied();
      }
    }
  } catch (error) {
    captureErrorInSentry(error);
  }
};

export const pushMessageNotification = () => {
  try {
    if (canSendNotification()) {
      const notification = new window.Notification('Qantas Hotels', {
        body: 'You have a new message',
        icon: qantasTail,
        tag: 'live-chat-notification',
      });

      notification.onclick = (event) => {
        window.focus();
        (event.target as Notification).close();
      };
      return notification;
    }
  } catch (error) {
    captureErrorInSentry(error);
  }
};
